import React, { useState } from 'react'
import styles from './TextField.module.css' 

export interface TextFieldProps {
    label: string
    required?: boolean
    disabled?: boolean
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export default function(props: TextFieldProps) {
    const [isActive, setIsActive] = useState(false)
    const [value, setValue] = useState("")

    const shrink = isActive || value.length > 0

    return (
        <div className={styles.textField}>
            <label className={shrink ? styles.shrink : ""}>
                {props.label}
            </label>
            <input
                type="text"
                onChange={(e) => {
                    setValue(e.target.value);
                    props.onChange && props.onChange(e);
                }}
                required={props.required}
                disabled={props.disabled}
                onFocus={() => setIsActive(true)}
                onBlur={() => setIsActive(false)}
            />
        </div>
    )
}